
import { colors2, Divider, TextInput } from "oolib";
import { ButtonSecondary } from "oolib/dist/v2/components/Buttons";
import React from "react";
import styled from "styled-components";


export const AlertButton = styled(ButtonSecondary)`
  background: ${colors2.redBG};
  color: ${colors2.red};
  width: 100%;
  /* margin: 1.4rem 0; */
`; 

// export const ReportSettingForm = ({ data, localReportMeta, setLocalReportMeta, setShowDeleteModal }) => {


//   return( <div style={{  padding: "1.4rem" }}>
//     <div style={{ display: "flex", flexDirection: "column",  gap: "1.4rem"}}>
//         <TextInput 
//           label={"Dashboard Name"}
//           value={localReportMeta.title}
//           onChange={(id, v) => setLocalReportMeta(prev => ({ ...prev, title: v }))}
//         />
//         <TextInput 
//           label={"About the Dashboard"}
//           value={localReportMeta.subtitle}
//           onChange={(id, v) => setLocalReportMeta(prev => ({ ...prev, subtitle: v }))}
//         />
//         <Divider style={{ margin: "0 -1.4rem" }}/>
//     </div>
    
//       <AlertButton 
//         onClick={() => setShowDeleteModal(true)}> 
//           Delete Report
//         </AlertButton>
//   </div>
//   )
// }